// extracted by mini-css-extract-plugin
module.exports = {"visibleOnMobileLayout":"ModalInMobileExample_visibleOnMobileLayout__2bRX3"};